<template>
  <div class="">
    <div class="section-header">
      <div class="section-title">
        <img class="section-icon" src="/img/orange.svg" />
        <h2>Providers</h2>
      </div>
      <div class="nav">
        <button class="nav-btn" @click="prevSlide">
          <ArrowLeftIcon />
        </button>

        <button class="nav-btn" @click="nextSlide">
          <ArrowLeftIcon style="transform: rotate(180deg)" />
        </button>
      </div>
    </div>
    <div class="provider-slider">
      <div
        class="carousel-track"
        :style="{
          transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
        }"
      >
        <div class="provider-logo" v-for="(logo, index) in logos" :key="index">
          <img :src="logo" alt="Provider logo" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArrowLeftIcon from "../../icons/ArrowLeftIcon.vue";

export default {
  name: "ProviderSlider",
  props: {
    logos: {
      type: Array,
      required: true,
    },
  },
  components: {
    ArrowLeftIcon,
  },
  data() {
    return {
      currentIndex: 0,
      visibleSlides: 6,
    };
  },
  methods: {
    nextSlide() {
      if (this.currentIndex < this.logos.length - this.visibleSlides) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    updateVisibleSlides() {
      if (window.innerWidth < 640) {
        this.visibleSlides = 2;
      } else {
        this.visibleSlides = 6;
      }
    },
  },
  mounted() {
    this.updateVisibleSlides();
    window.addEventListener("resize", this.updateVisibleSlides);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateVisibleSlides);
  },
};
</script>
<style scoped>
.provider-slider {
  padding: 2rem 16px;
  width: 100%;
  overflow: hidden;
  background-color: rgb(21 21 23);
  border-radius: 24px;
}
.carousel-track {
  display: flex;
  transition: transform 0.6s ease;
  width: 100%;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.section-icon {
  font-size: 20px;
}

.nav {
  display: flex;
  gap: 8px;
}

.nav-btn {
  color: white;
  cursor: pointer;
}

.provider-logo {
  flex: 0 0 calc(100% / 6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.provider-logo img {
  max-width: 100%;
  max-height: 40px;
  filter: grayscale(1);
  opacity: 0.8;
}

@media only screen and (max-width: 640px) {
  .provider-logo {
    flex: 0 0 calc(100% / 2);
  }
}
</style>
